import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/index.css";
import store from "./store";
import Keycloak from "keycloak-js";
import * as cfg from "./config";
import KeycloakWrapper from "@authzsvc/keycloak-js-react";

const keycloak = new Keycloak({
  url: cfg.keycloakUrl,
  realm: cfg.keycloakRealm,
  clientId: cfg.keycloakClientId,
});

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <KeycloakWrapper
        keycloak={keycloak}
        refresh={false}
        keycloakParams={{
          onLoad: "login-required",
          flow: "implicit",
        }}
      >
        <App />
      </KeycloakWrapper>
    </BrowserRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
